import cn from 'clsx'
import { Link } from '@ds/components'
import type { TNavEntryView } from '../types'
import styles from './Navigation.module.css'

type TNavLinkProps = {
    entry: Extract<TNavEntryView, { kind: 'link' }>
}

export const NavLink = ({ entry }: TNavLinkProps) => (
    <Link
        variant="primary"
        href={entry.href}
        className={cn(styles.navLink, entry.isBrand && styles.navPro)}
        onClick={entry.onClick}
    >
        {entry.label}
    </Link>
)
